(function () {
    'use strict';

    angular.module("imApp").factory("dataMiningListService", ['$ihttp', function ($ihttp) {
        let service = {
            listDataMinings: function (parms) {
                return $ihttp.post({
                    method: 811,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
